import {combineReducers} from 'redux';

const initialState = {
  mixcloudSlug: 'no-slug',
};


export const SET_MIXCLOUD_SLUG = 'SET_MIXCLOUD_SLUG'

export function mixcloudReducer (state = initialState, action)  {
  switch (action.type) {
    case 'SET_MIXCLOUD_SLUG':
//      console.log(state);
      return {
        ...state,
        mixcloudSlug: action.payload,
      };
    default:
      return state;
  }
};



const reducer = combineReducers({
  mixcloud:mixcloudReducer
});

export default reducer;
